export default {
    LIST: 'list',
    REPLAY: 'replay',
};
